module.exports = {
  "pageview": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "showAppRelatedInstallStats": {
        "type": "boolean",
        "isOptional": true
      },
      "appRelatedIndustryStat": {
        "type": "number",
        "isOptional": true
      },
      "appRelatedCountryStat": {
        "type": "number",
        "isOptional": true
      },
      "appRelatedPlanStat": {
        "type": "number",
        "isOptional": true
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "type": [
        "integration"
      ],
      "sessionUrlParams": "array"
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "nextStep": {
        "type": "string",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "filter": {
        "type": "string",
        "isOptional": true
      },
      "filter_key": {
        "type": "string",
        "isOptional": true
      },
      "feature": {
        "type": "string",
        "isOptional": true
      },
      "page_type": {
        "type": "string",
        "isOptional": true
      },
      "payment_type": {
        "type": "string",
        "isOptional": true
      },
      "prev_step": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "type": [
        "integration"
      ],
      "sessionUrlParams": "array"
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "storefront-pageview": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": [
        "storefront"
      ],
      "name": {
        "type": "array",
        "isOptional": true
      },
      "showRecommended": {
        "type": "boolean",
        "isOptional": true
      },
      "recommendationType": {
        "type": "array",
        "isOptional": true
      },
      "topRecommendationsCount": {
        "type": "number",
        "isOptional": true
      },
      "appLanguages": {
        "type": "string",
        "isOptional": true
      },
      "limit": {
        "type": "string",
        "isOptional": true
      },
      "showPreferredLanguageFirst": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "preferredLanguage": "string",
      "category": {
        "type": "array",
        "isOptional": true
      },
      "feature": {
        "type": "array",
        "isOptional": true
      },
      "paymentType": {
        "type": "string",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "tier": {
        "type": "array",
        "isOptional": true
      },
      "tool": {
        "type": "array",
        "isOptional": true
      },
      "integrationsSyncAccess": {
        "type": "string",
        "isOptional": true
      },
      "listingStatus": {
        "type": "string",
        "isOptional": true
      },
      "integration": {
        "type": "array",
        "isOptional": true
      },
      "provider": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "array",
        "isOptional": true
      },
      "sortField": {
        "type": "string",
        "isOptional": true
      },
      "sortOrder": {
        "type": "string",
        "isOptional": true
      },
      "search": {
        "type": "string",
        "isOptional": true
      },
      "searchLength": {
        "type": "number",
        "isOptional": true
      },
      "pageNumber": {
        "type": "number",
        "isOptional": true
      },
      "totalResults": {
        "type": "number",
        "isOptional": true
      },
      "filter": {
        "type": "string",
        "isOptional": true
      },
      "filterCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "storefront-filter": {
    "name": "filter",
    "class": "view",
    "properties": {
      "screen": [
        "storefront"
      ],
      "showRecommended": {
        "type": "boolean",
        "isOptional": true
      },
      "recommendationType": {
        "type": "array",
        "isOptional": true
      },
      "topRecommendationsCount": {
        "type": "number",
        "isOptional": true
      },
      "appLanguages": {
        "type": "string",
        "isOptional": true
      },
      "limit": {
        "type": "string",
        "isOptional": true
      },
      "showPreferredLanguageFirst": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "preferredLanguage": "string",
      "category": {
        "type": "array",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "feature": {
        "type": "array",
        "isOptional": true
      },
      "paymentType": {
        "type": "string",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "tier": {
        "type": "array",
        "isOptional": true
      },
      "tool": {
        "type": "array",
        "isOptional": true
      },
      "integrationsSyncAccess": {
        "type": "string",
        "isOptional": true
      },
      "listingStatus": {
        "type": "string",
        "isOptional": true
      },
      "integration": {
        "type": "array",
        "isOptional": true
      },
      "provider": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "array",
        "isOptional": true
      },
      "sortField": {
        "type": "string",
        "isOptional": true
      },
      "sortOrder": {
        "type": "string",
        "isOptional": true
      },
      "search": {
        "type": "string",
        "isOptional": true
      },
      "searchLength": {
        "type": "number",
        "isOptional": true
      },
      "pageNumber": {
        "type": "number",
        "isOptional": true
      },
      "totalResults": {
        "type": "number",
        "isOptional": true
      },
      "filter": {
        "type": "string",
        "isOptional": true
      },
      "filterCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "storefront-interaction": {
    "name": "storefront interaction",
    "class": "interaction",
    "properties": {
      "screen": [
        "storefront"
      ],
      "action": [
        "click manage apps button",
        "click build button",
        "submit search",
        "search app integrations",
        "search hubspot features",
        "click see all collection",
        "close filter tag",
        "clear all filters",
        "no results returned",
        "click collection",
        "click featured apps link",
        "click featured callout",
        "click copilot chat button",
        "click copilot summarize button",
        "click copilot suggest button"
      ],
      "itemIndex": {
        "type": "number",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "appLanguages": {
        "type": "string",
        "isOptional": true
      },
      "limit": {
        "type": "string",
        "isOptional": true
      },
      "showPreferredLanguageFirst": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "preferredLanguage": "string",
      "category": {
        "type": "array",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "feature": {
        "type": "array",
        "isOptional": true
      },
      "paymentType": {
        "type": "string",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "tier": {
        "type": "array",
        "isOptional": true
      },
      "tool": {
        "type": "array",
        "isOptional": true
      },
      "integrationsSyncAccess": {
        "type": "string",
        "isOptional": true
      },
      "listingStatus": {
        "type": "string",
        "isOptional": true
      },
      "integration": {
        "type": "array",
        "isOptional": true
      },
      "provider": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "array",
        "isOptional": true
      },
      "sortField": {
        "type": "string",
        "isOptional": true
      },
      "sortOrder": {
        "type": "string",
        "isOptional": true
      },
      "search": {
        "type": "string",
        "isOptional": true
      },
      "searchLength": {
        "type": "number",
        "isOptional": true
      },
      "pageNumber": {
        "type": "number",
        "isOptional": true
      },
      "totalResults": {
        "type": "number",
        "isOptional": true
      },
      "filter": {
        "type": "string",
        "isOptional": true
      },
      "filterCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "storefront-select-search-category": {
    "name": "storefront interaction",
    "class": "interaction",
    "properties": {
      "screen": [
        "storefront"
      ],
      "action": [
        "select search category"
      ],
      "value": "string",
      "appLanguages": {
        "type": "string",
        "isOptional": true
      },
      "limit": {
        "type": "string",
        "isOptional": true
      },
      "showPreferredLanguageFirst": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "preferredLanguage": "string",
      "category": {
        "type": "array",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "feature": {
        "type": "array",
        "isOptional": true
      },
      "paymentType": {
        "type": "string",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "tier": {
        "type": "array",
        "isOptional": true
      },
      "tool": {
        "type": "array",
        "isOptional": true
      },
      "integrationsSyncAccess": {
        "type": "string",
        "isOptional": true
      },
      "listingStatus": {
        "type": "string",
        "isOptional": true
      },
      "integration": {
        "type": "array",
        "isOptional": true
      },
      "provider": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "array",
        "isOptional": true
      },
      "sortField": {
        "type": "string",
        "isOptional": true
      },
      "sortOrder": {
        "type": "string",
        "isOptional": true
      },
      "search": {
        "type": "string",
        "isOptional": true
      },
      "searchLength": {
        "type": "number",
        "isOptional": true
      },
      "pageNumber": {
        "type": "number",
        "isOptional": true
      },
      "totalResults": {
        "type": "number",
        "isOptional": true
      },
      "filter": {
        "type": "string",
        "isOptional": true
      },
      "filterCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "storefront-select-search-autofill-item": {
    "name": "storefront interaction",
    "class": "interaction",
    "properties": {
      "screen": [
        "storefront"
      ],
      "action": [
        "select search autofill item"
      ],
      "resultType": [
        "app",
        "category",
        "category feature",
        "hubspot feature",
        "integration",
        "recent search",
        "see more",
        "search all categories"
      ],
      "value": {
        "type": "string",
        "isOptional": true
      },
      "totalResults": {
        "type": "number",
        "isOptional": true
      },
      "isRecommended": {
        "type": "boolean",
        "isOptional": true
      },
      "search": {
        "type": "string"
      },
      "itemIndex": {
        "type": "number"
      },
      "appLanguages": {
        "type": "string",
        "isOptional": true
      },
      "limit": {
        "type": "string",
        "isOptional": true
      },
      "showPreferredLanguageFirst": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "preferredLanguage": "string",
      "category": {
        "type": "array",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "feature": {
        "type": "array",
        "isOptional": true
      },
      "paymentType": {
        "type": "string",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "tier": {
        "type": "array",
        "isOptional": true
      },
      "tool": {
        "type": "array",
        "isOptional": true
      },
      "integrationsSyncAccess": {
        "type": "string",
        "isOptional": true
      },
      "listingStatus": {
        "type": "string",
        "isOptional": true
      },
      "integration": {
        "type": "array",
        "isOptional": true
      },
      "provider": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "array",
        "isOptional": true
      },
      "sortField": {
        "type": "string",
        "isOptional": true
      },
      "sortOrder": {
        "type": "string",
        "isOptional": true
      },
      "searchLength": {
        "type": "number",
        "isOptional": true
      },
      "pageNumber": {
        "type": "number",
        "isOptional": true
      },
      "filter": {
        "type": "string",
        "isOptional": true
      },
      "filterCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "storefront-change-filter": {
    "name": "storefront interaction",
    "class": "interaction",
    "properties": {
      "screen": [
        "storefront"
      ],
      "action": [
        "change filter"
      ],
      "filter": "string",
      "value": "string",
      "appLanguages": {
        "type": "string",
        "isOptional": true
      },
      "limit": {
        "type": "string",
        "isOptional": true
      },
      "showPreferredLanguageFirst": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "preferredLanguage": "string",
      "category": {
        "type": "array",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "feature": {
        "type": "array",
        "isOptional": true
      },
      "paymentType": {
        "type": "string",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "tier": {
        "type": "array",
        "isOptional": true
      },
      "tool": {
        "type": "array",
        "isOptional": true
      },
      "integrationsSyncAccess": {
        "type": "string",
        "isOptional": true
      },
      "listingStatus": {
        "type": "string",
        "isOptional": true
      },
      "integration": {
        "type": "array",
        "isOptional": true
      },
      "provider": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "array",
        "isOptional": true
      },
      "sortField": {
        "type": "string",
        "isOptional": true
      },
      "sortOrder": {
        "type": "string",
        "isOptional": true
      },
      "search": {
        "type": "string",
        "isOptional": true
      },
      "searchLength": {
        "type": "number",
        "isOptional": true
      },
      "pageNumber": {
        "type": "number",
        "isOptional": true
      },
      "totalResults": {
        "type": "number",
        "isOptional": true
      },
      "filterCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "storefront-change-filter-set": {
    "name": "storefront interaction",
    "class": "interaction",
    "properties": {
      "screen": [
        "storefront"
      ],
      "action": [
        "change filter"
      ],
      "filter": "string",
      "value": "array",
      "appLanguages": {
        "type": "string",
        "isOptional": true
      },
      "limit": {
        "type": "string",
        "isOptional": true
      },
      "showPreferredLanguageFirst": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "preferredLanguage": "string",
      "category": {
        "type": "array",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "feature": {
        "type": "array",
        "isOptional": true
      },
      "paymentType": {
        "type": "string",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "tier": {
        "type": "array",
        "isOptional": true
      },
      "tool": {
        "type": "array",
        "isOptional": true
      },
      "integrationsSyncAccess": {
        "type": "string",
        "isOptional": true
      },
      "listingStatus": {
        "type": "string",
        "isOptional": true
      },
      "integration": {
        "type": "array",
        "isOptional": true
      },
      "provider": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "array",
        "isOptional": true
      },
      "sortField": {
        "type": "string",
        "isOptional": true
      },
      "sortOrder": {
        "type": "string",
        "isOptional": true
      },
      "search": {
        "type": "string",
        "isOptional": true
      },
      "searchLength": {
        "type": "number",
        "isOptional": true
      },
      "pageNumber": {
        "type": "number",
        "isOptional": true
      },
      "totalResults": {
        "type": "number",
        "isOptional": true
      },
      "filterCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "storefront-change-filter-boolean": {
    "name": "storefront interaction",
    "class": "interaction",
    "properties": {
      "screen": [
        "storefront"
      ],
      "action": [
        "change filter"
      ],
      "filter": "string",
      "value": "boolean",
      "appLanguages": {
        "type": "string",
        "isOptional": true
      },
      "limit": {
        "type": "string",
        "isOptional": true
      },
      "showPreferredLanguageFirst": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "preferredLanguage": "string",
      "category": {
        "type": "array",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "feature": {
        "type": "array",
        "isOptional": true
      },
      "paymentType": {
        "type": "string",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "tier": {
        "type": "array",
        "isOptional": true
      },
      "tool": {
        "type": "array",
        "isOptional": true
      },
      "integrationsSyncAccess": {
        "type": "string",
        "isOptional": true
      },
      "listingStatus": {
        "type": "string",
        "isOptional": true
      },
      "integration": {
        "type": "array",
        "isOptional": true
      },
      "provider": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "array",
        "isOptional": true
      },
      "sortField": {
        "type": "string",
        "isOptional": true
      },
      "sortOrder": {
        "type": "string",
        "isOptional": true
      },
      "search": {
        "type": "string",
        "isOptional": true
      },
      "searchLength": {
        "type": "number",
        "isOptional": true
      },
      "pageNumber": {
        "type": "number",
        "isOptional": true
      },
      "totalResults": {
        "type": "number",
        "isOptional": true
      },
      "filterCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "storefront-change-sort": {
    "name": "storefront interaction",
    "class": "interaction",
    "properties": {
      "screen": [
        "storefront"
      ],
      "action": [
        "change sort"
      ],
      "sortField": "string",
      "sortOrder": "string",
      "appLanguages": {
        "type": "string",
        "isOptional": true
      },
      "limit": {
        "type": "string",
        "isOptional": true
      },
      "showPreferredLanguageFirst": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "preferredLanguage": "string",
      "category": {
        "type": "array",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "feature": {
        "type": "array",
        "isOptional": true
      },
      "paymentType": {
        "type": "string",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "tier": {
        "type": "array",
        "isOptional": true
      },
      "tool": {
        "type": "array",
        "isOptional": true
      },
      "integrationsSyncAccess": {
        "type": "string",
        "isOptional": true
      },
      "listingStatus": {
        "type": "string",
        "isOptional": true
      },
      "integration": {
        "type": "array",
        "isOptional": true
      },
      "provider": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "array",
        "isOptional": true
      },
      "search": {
        "type": "string",
        "isOptional": true
      },
      "searchLength": {
        "type": "number",
        "isOptional": true
      },
      "pageNumber": {
        "type": "number",
        "isOptional": true
      },
      "totalResults": {
        "type": "number",
        "isOptional": true
      },
      "filter": {
        "type": "string",
        "isOptional": true
      },
      "filterCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "storefront-featured-apps-interaction": {
    "name": "storefront interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "click breadcrumb link",
        "click collection",
        "change collections page"
      ],
      "value": {
        "type": "string",
        "isOptional": true
      },
      "appLanguages": {
        "type": "string",
        "isOptional": true
      },
      "limit": {
        "type": "string",
        "isOptional": true
      },
      "showPreferredLanguageFirst": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "screen": [
        "storefront"
      ],
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "preferredLanguage": "string",
      "category": {
        "type": "array",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "feature": {
        "type": "array",
        "isOptional": true
      },
      "paymentType": {
        "type": "string",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "tier": {
        "type": "array",
        "isOptional": true
      },
      "tool": {
        "type": "array",
        "isOptional": true
      },
      "integrationsSyncAccess": {
        "type": "string",
        "isOptional": true
      },
      "listingStatus": {
        "type": "string",
        "isOptional": true
      },
      "integration": {
        "type": "array",
        "isOptional": true
      },
      "provider": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "array",
        "isOptional": true
      },
      "sortField": {
        "type": "string",
        "isOptional": true
      },
      "sortOrder": {
        "type": "string",
        "isOptional": true
      },
      "search": {
        "type": "string",
        "isOptional": true
      },
      "searchLength": {
        "type": "number",
        "isOptional": true
      },
      "pageNumber": {
        "type": "number",
        "isOptional": true
      },
      "totalResults": {
        "type": "number",
        "isOptional": true
      },
      "filter": {
        "type": "string",
        "isOptional": true
      },
      "filterCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "listing-detail-pageview": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": [
        "detail"
      ],
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "referrer": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "applicationId": "number",
      "applicationName": "string",
      "preferredLanguage": "string",
      "contentLanguage": "string",
      "slug": "string",
      "ipaasApplicationName": {
        "type": "string",
        "isOptional": true
      },
      "ipaasApplicationId": {
        "type": "number",
        "isOptional": true
      },
      "category": {
        "type": "array",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "isInstallableByUser": {
        "type": "boolean",
        "isOptional": true
      },
      "isNotInstallableReason": {
        "type": "string",
        "isOptional": true
      },
      "certification": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "listing-detail-preview-pageview": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": [
        "detail preview"
      ],
      "category": {
        "type": "array",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "referrer": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "applicationId": "number",
      "applicationName": "string",
      "preferredLanguage": "string",
      "contentLanguage": "string",
      "slug": "string",
      "ipaasApplicationName": {
        "type": "string",
        "isOptional": true
      },
      "ipaasApplicationId": {
        "type": "number",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "isInstallableByUser": {
        "type": "boolean",
        "isOptional": true
      },
      "isNotInstallableReason": {
        "type": "string",
        "isOptional": true
      },
      "certification": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "listing-detail-review-pageview": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": [
        "detail review"
      ],
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "referrer": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "applicationId": "number",
      "applicationName": "string",
      "preferredLanguage": "string",
      "contentLanguage": "string",
      "slug": "string",
      "ipaasApplicationName": {
        "type": "string",
        "isOptional": true
      },
      "ipaasApplicationId": {
        "type": "number",
        "isOptional": true
      },
      "category": {
        "type": "array",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "isInstallableByUser": {
        "type": "boolean",
        "isOptional": true
      },
      "isNotInstallableReason": {
        "type": "string",
        "isOptional": true
      },
      "certification": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "all-reviews-pageview": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": [
        "all reviews"
      ],
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "referrer": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "applicationId": "number",
      "applicationName": "string",
      "preferredLanguage": "string",
      "contentLanguage": "string",
      "slug": "string",
      "ipaasApplicationName": {
        "type": "string",
        "isOptional": true
      },
      "ipaasApplicationId": {
        "type": "number",
        "isOptional": true
      },
      "category": {
        "type": "array",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "isInstallableByUser": {
        "type": "boolean",
        "isOptional": true
      },
      "isNotInstallableReason": {
        "type": "string",
        "isOptional": true
      },
      "certification": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "listing-detail-click-connect": {
    "name": "click install button",
    "class": "usage",
    "properties": {
      "offering_id": {
        "type": "string",
        "isOptional": true
      },
      "homemade": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "referrer": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "applicationId": "number",
      "applicationName": "string",
      "preferredLanguage": "string",
      "contentLanguage": "string",
      "slug": "string",
      "ipaasApplicationName": {
        "type": "string",
        "isOptional": true
      },
      "ipaasApplicationId": {
        "type": "number",
        "isOptional": true
      },
      "category": {
        "type": "array",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "isInstallableByUser": {
        "type": "boolean",
        "isOptional": true
      },
      "isNotInstallableReason": {
        "type": "string",
        "isOptional": true
      },
      "certification": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "listing-detail-request-install-app-permission": {
    "name": "request install app permission",
    "class": "usage",
    "properties": {
      "offering_id": {
        "type": "string",
        "isOptional": true
      },
      "homemade": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "referrer": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "applicationId": "number",
      "applicationName": "string",
      "preferredLanguage": "string",
      "contentLanguage": "string",
      "slug": "string",
      "ipaasApplicationName": {
        "type": "string",
        "isOptional": true
      },
      "ipaasApplicationId": {
        "type": "number",
        "isOptional": true
      },
      "category": {
        "type": "array",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "isInstallableByUser": {
        "type": "boolean",
        "isOptional": true
      },
      "isNotInstallableReason": {
        "type": "string",
        "isOptional": true
      },
      "certification": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "listing-detail-interaction": {
    "name": "listing detail interaction",
    "class": "interaction",
    "properties": {
      "review_source": {
        "type": "string",
        "isOptional": true
      },
      "offering_id": {
        "type": "string",
        "isOptional": true
      },
      "is_field_mapping_section_open": {
        "type": "string",
        "isOptional": true
      },
      "prev_step": {
        "type": "string",
        "isOptional": true
      },
      "homemade": {
        "type": "string",
        "isOptional": true
      },
      "action": [
        "click view setup guide",
        "click tab navigation",
        "click breadcrumb link",
        "click request install app permission button",
        "click schedule demo",
        "click schedule demo dropdown",
        "click schedule meeting",
        "click request to be contacted",
        "complete hubspot oauth",
        "open third party sign in pop up",
        "focus third party sign in pop up",
        "complete third party sign in",
        "click explore app features link",
        "close install wizard",
        "select video/screenshot",
        "start video",
        "complete video",
        "click carousel screenshot",
        "click integration feature screenshot",
        "click compare features by plan",
        "click compatibility modal pricing link",
        "click feature required plan pricing link",
        "click feature required compare by plan link",
        "hover shared data description",
        "click data sync badge",
        "toggle field mapping section open",
        "click provider link",
        "click category link",
        "click features link",
        "click tiers tooltip pricing link",
        "click public pricing link",
        "click partial plan compatibility",
        "click account plan link",
        "click app pricing link",
        "click see all compatible plans popover",
        "click required account permissions",
        "hover subscription help icon",
        "click setup guide link",
        "click support website link",
        "click case study link",
        "click copy email address",
        "click company website link",
        "click live chat link",
        "click facebook link",
        "click privacy policy link",
        "click product privacy policy link",
        "click terms link",
        "click other privacy policy link",
        "click acceptable use policy link",
        "click customer terms of service link",
        "click report this app link",
        "click agency pricing link",
        "click software pricing link",
        "toggle plan commitment pricing",
        "click get service",
        "click more apps result item",
        "click more apps see all link",
        "open review wizard",
        "open edit review wizard",
        "change review wizard step",
        "submit review",
        "dismiss review wizard",
        "change reviews filter",
        "change reviews sort",
        "change reviews page",
        "change reviews search",
        "change reviews industry",
        "change reviews employees",
        "generated review title selected",
        "generated review title edited",
        "set overall rating",
        "click support link",
        "show detailed ratings",
        "hide detailed ratings",
        "add detailed rating",
        "add review answer",
        "show review translation tooltip",
        "click show untranslated review",
        "click show translated review",
        "generated lead"
      ],
      "section": [
        "header",
        "overview",
        "details",
        "requirements",
        "resources",
        "contact",
        "data privacy",
        "report",
        "pricing",
        "more apps",
        "get started",
        "cta banner",
        "review",
        "all reviews",
        "lead generation consent modal",
        "opt out lead generation consent modal",
        "data sharing"
      ],
      "value": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "source": {
        "type": "string",
        "isOptional": true
      },
      "referrer": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "integration"
      ],
      "inAppOrPublic": [
        "public",
        "in-app"
      ],
      "applicationId": "number",
      "applicationName": "string",
      "preferredLanguage": "string",
      "contentLanguage": "string",
      "slug": "string",
      "ipaasApplicationName": {
        "type": "string",
        "isOptional": true
      },
      "ipaasApplicationId": {
        "type": "number",
        "isOptional": true
      },
      "category": {
        "type": "array",
        "isOptional": true
      },
      "isCompatible": {
        "type": "boolean",
        "isOptional": true
      },
      "isInstallableByUser": {
        "type": "boolean",
        "isOptional": true
      },
      "isNotInstallableReason": {
        "type": "string",
        "isOptional": true
      },
      "certification": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "marketplace",
    "version": "1"
  },
  "marketplaceInteraction": {
    "name": "marketplace interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "inAppOrPublic": {
        "type": [
          "in-app",
          "public"
        ],
        "isOptional": true
      },
      "type": {
        "type": [
          "integration",
          "theme",
          "module"
        ],
        "isOptional": true
      },
      "embed": {
        "type": "boolean",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "marketplace"
  },
  "marketplaceClickResultItem": {
    "name": "marketplace interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "click result item"
      ],
      "itemIndex": "number",
      "pageNumber": {
        "type": "number",
        "isOptional": true
      },
      "search": "string",
      "totalResults": "number",
      "value": "string",
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "inAppOrPublic": {
        "type": [
          "in-app",
          "public"
        ],
        "isOptional": true
      },
      "type": {
        "type": [
          "integration",
          "theme",
          "module"
        ],
        "isOptional": true
      },
      "embed": {
        "type": "boolean",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "marketplace"
  },
  "appMarketplaceClickResultItem": {
    "name": "marketplace interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "click result item"
      ],
      "itemIndex": "number",
      "pageNumber": {
        "type": "number",
        "isOptional": true
      },
      "search": "string",
      "totalResults": "number",
      "value": "string",
      "applicationId": "number",
      "isRecommended": "boolean",
      "category": {
        "type": "string",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "preferredLanguage": {
        "type": "string",
        "isOptional": true
      },
      "recommendationType": {
        "type": "array",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "inAppOrPublic": {
        "type": [
          "in-app",
          "public"
        ],
        "isOptional": true
      },
      "type": {
        "type": [
          "integration",
          "theme",
          "module"
        ],
        "isOptional": true
      },
      "embed": {
        "type": "boolean",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "marketplace"
  },
  "solutionsDirectoryClickResultItem": {
    "name": "marketplace interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "click result item"
      ],
      "itemIndex": "number",
      "pageNumber": {
        "type": "number",
        "isOptional": true
      },
      "search": "string",
      "totalResults": "number",
      "value": "string",
      "tier": "string",
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "inAppOrPublic": {
        "type": [
          "in-app",
          "public"
        ],
        "isOptional": true
      },
      "type": {
        "type": [
          "integration",
          "theme",
          "module"
        ],
        "isOptional": true
      },
      "embed": {
        "type": "boolean",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "sessionUrlParams": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "marketplace"
  }
};